<template>
  <div v-show="position.show">
    <!-- <a-progress type="circle" :percent="textData" :width="80" strokeColor="#000" /> -->
    <div v-if="option.dataTrue === false" :style="backGroundColorStyle">
      <a-progress
        type="circle"
        :width="option.width"
        :height="option.height"
        :percent="
          textData
            | dataFormat(option.decimalNum, option.totalCustomValueSwitch, option.totalCustomValue, option.dataTrue)
        "
        :strokeWidth="option.fontWeight"
        :strokeColor="option.progressColor"
        :style="fontStyle"
      >
        <template #format="percent">
          <span :style="fontStyle">{{ percent + '%' }}</span>
        </template>
      </a-progress>
    </div>
    <div v-else :style="backGroundColorStyle">
      <a-progress
        type="circle"
        :percent="
          textData
            | dataFormat(option.decimalNum, option.totalCustomValueSwitch, option.totalCustomValue, option.dataTrue)
        "
        :strokeWidth="option.fontWeight"
        :strokeColor="option.progressColor"
        :width="option.width"
        :height="option.height"
      >
        <template #format="percent" v-if="option.dataTrue">
          <span :style="fontStyle">{{ percent }}</span>
        </template>
      </a-progress>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Progress } from 'ant-design-vue'
Vue.use(Progress)
export default {
  // 导航配置组件
  name: 'CircularProgressBar',
  components: {
    // HIcon
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    position: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  filters: {
    dataFormat(textData, decimalNum, totalCustomValueSwitch, totalCustomValue, dataTrue) {
      // console.log('123', textData, decimalNum, totalCustomValueSwitch, totalCustomValue)
      let fixedData = 0
      fixedData = parseFloat(textData.toFixed(decimalNum)) // 保留几位小数后的值
      // 自定义总值开关开启
      if (totalCustomValueSwitch) {
        // 占比
        let proportion = 1
        if (dataTrue) {
          proportion = fixedData / totalCustomValue
        } else {
          proportion = (fixedData / totalCustomValue) * 100
        }
        // console.log('789', proportion)
        parseFloat(proportion.toFixed(decimalNum))
        return parseFloat(proportion.toFixed(decimalNum))
      } else {
        // 自定义总值开关 关闭
        return fixedData
      }
    }
  },
  computed: {
    fontStyle() {
      const fontstyle = {
        'font-size': `${this.option.fontSize}px`, // 字体大小
        color: this.option.color, // 字体颜色
        'background-color': this.option.backGroundColorProgress // 进度条背景颜色
      }
      return fontstyle
    },
    // 背景颜色
    backGroundColorStyle() {
      const fontstyle = {
        'background-color': this.option.backgroundColor, // 背景颜色
        'text-align': this.option.textAlign
      }
      return fontstyle
    },
    textData() {
      const data = this.option.data
      return parseFloat(data)

      // return data
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .ant-progress-circle .ant-progress-text {
  color: none;
}
::v-deep.ant-progress-text {
  color: none;
}
::v-deep .ant-progress-circle-trail {
  // stroke:#175372 !important
  stroke: #ccc !important;
}
</style>
